/* es6-symbol/index */ function _(require, module, exports) {
    module.exports = require(385) /* ./is-implemented */() ? Symbol : require(387) /* ./polyfill */;
}
